/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_TitleInputs */

const en_directory_home_hero_title = /** @type {(inputs: Directory_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your job done with the right AI`)
};

const zh_directory_home_hero_title = /** @type {(inputs: Directory_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把事办成的 AI，一次找齐`)
};

/**
* | output |
* | --- |
* | "Get your job done with the right AI" |
*
* @param {Directory_Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_title = /** @type {((inputs?: Directory_Home_Hero_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_title(inputs)
	return zh_directory_home_hero_title(inputs)
});
export { directory_home_hero_title as "directory.home.hero.title" }